import { render } from "./StudentTeacherTimeTableModal.vue?vue&type=template&id=4f17a1cc&scoped=true"
import script from "./StudentTeacherTimeTableModal.vue?vue&type=script&lang=js"
export * from "./StudentTeacherTimeTableModal.vue?vue&type=script&lang=js"

import "./StudentTeacherTimeTableModal.vue?vue&type=style&index=0&id=4f17a1cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f17a1cc"]])

export default __exports__